"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HtmlSwitch = void 0;
var _core = require("@dragon/core");
require("./HtmlSwitch.scss");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * 
 <div class="display">
  <label class="label toggle">
    <input type="checkbox" class="toggle_input" />
    <div class="toggle-control"></div>
  </label>
</div>
 */
var HtmlSwitch = exports.HtmlSwitch = /*#__PURE__*/_createClass(function HtmlSwitch(parent, label, id, sound) {
  var _this = this;
  _classCallCheck(this, HtmlSwitch);
  _defineProperty(this, "_id", void 0);
  _defineProperty(this, "_node", void 0);
  _defineProperty(this, "_input", void 0);
  _defineProperty(this, "check", function () {
    _this._input.checked = true;
  });
  _defineProperty(this, "unCheck", function () {
    _this._input.checked = false;
  });
  this._id = id;
  this._node = document.createElement("label");
  this._node.className = "label toggle";
  this._node.innerHTML = label;
  this._input = document.createElement("input");
  this._input.className = "toggle_input";
  this._input.setAttribute("type", "checkbox");
  this._input.checked = false;
  this._input.addEventListener("change", function () {
    if (sound) {
      _core.CORE.dispatch((0, _core.playSound)(_core.SoundPack.Shared, false, "uitoggle"));
    }
    _core.CORE.dispatch({
      type: _this._id,
      payload: _this._input.checked
    });
  });
  this._node.appendChild(this._input);
  var span = document.createElement("div");
  span.className = "toggle-control";
  this._node.appendChild(span);
  parent.appendChild(this._node);
});
//# sourceMappingURL=HtmlSwitch.js.map